export default "__VITE_ASSET__Csm$BQcG__"